import { useContext, useEffect, useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import { User } from "@/models";
import {
  User as graphUser,
  GetUsersQuery,
  useGetUsersLazyQuery,
} from "@/generated/graphql";
import { AuthContext, AuthStatus } from "@/contexts/AuthContext";
import useRollbarUtil from "../hooks/useRollbarUtil";

const usersFromQueryResult = (data: GetUsersQuery) => {
  let users: User[] = [];
  data.users.users.forEach((element: graphUser) => {
    users.push(new User(element));
  });
  return users;
};

type Props = {
  columns: TableColumn<User>[];
  rowsPerPage: number;
};

export const UsersTable = ({ columns, rowsPerPage }: Props) => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();
  const { authStatus } = useContext(AuthContext);
  const [users, setUsers] = useState<User[]>([]);
  const [totalRows, setTotalRows] = useState<Number>(1);
  const [getUsersQuery, { loading }] = useGetUsersLazyQuery({
    onCompleted: (data) => {
      if (data) {
        setUsers(usersFromQueryResult(data));
        setTotalRows(data.users.users.length ?? 0);
      }
    },
    onError: getNotifyErrorHandlerForGraphQL("Failed to get users"),
  });

  useEffect(() => {
    if (authStatus === AuthStatus.SignedIn) {
      getUsersQuery({ variables: { first: 1000, after: "" } });
    }
  }, [authStatus]);

  return (
    <DataTable
      columns={columns}
      data={users}
      defaultSortFieldId={2}
      defaultSortAsc={false}
      highlightOnHover
      progressPending={loading}
      pagination
      paginationTotalRows={Number(totalRows)}
      paginationPerPage={rowsPerPage}
      paginationComponentOptions={{ noRowsPerPage: true }}
    />
  );
};
